import { Link } from "react-router-dom";
import { getShopProductPath } from "../utils/productHelpers";

const DEFAULT_CLASS_NAME =
  "inline font-medium text-neutral-900 transition hover:text-indigo-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 dark:text-neutral-100 dark:hover:text-indigo-400 dark:focus-visible:ring-offset-neutral-900";

export default function ShopProductNameLink({
  product,
  children,
  className = "",
  fallbackClassName = "",
  onClick,
}) {
  const productPath = getShopProductPath(product);
  const label = children ?? product?.name ?? product?.product?.name ?? "Product";

  if (!productPath) {
    return <span className={fallbackClassName || className}>{label}</span>;
  }

  return (
    <Link
      to={productPath}
      onClick={onClick}
      className={`${DEFAULT_CLASS_NAME} ${className}`.trim()}
    >
      {label}
    </Link>
  );
}
